<template>
  <tile-card
    :icon="icon"
    :iconColor="'primary'"
    :title="file.title"
    :subtitle="subtitle"
    :border-radius="'10px'"
    titleStyle="font-size: 16px; font-weight: bold"
    :textOnMouseOver="file.title"
    :backgroundColor="'white'"
    contentPadding="px-10"
    @click="openURL"
  ></tile-card>
</template>

<script>
import TileCard from '@/components/TileCard.vue';

export default {
  components: { TileCard },

  props: {
    file: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    cardTypes: [
      { icon: 'insert_drive_file', subtitle: 'Arquivo', mimeType: '' },
      { icon: 'image', subtitle: 'Imagem', mimeType: 'image' },
      { icon: 'music_note', subtitle: 'Áudio', mimeType: 'audio' },
      { icon: 'movie', subtitle: 'Vídeo', mimeType: 'video' },
    ],
  }),

  methods: {
    openURL() {
      window.open(this.file.url);
    },
  },

  computed: {
    cardType() {
      const filteredType = this.cardTypes.filter(
        file => file.mimeType === this.file.mimeType,
      )[0];
      return filteredType || this.cardTypes[0];
    },
    icon() {
      return this.cardType.icon;
    },
    subtitle() {
      return this.cardType.subtitle;
    },
  },
};
</script>
